module.exports = __webpack_public_path__ + "img/blog_cards_md.d3679807.png";